"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHttpCache = exports.HttpCache = void 0;
var abstract_1 = require("./abstract");
Object.defineProperty(exports, "HttpCache", { enumerable: true, get: function () { return abstract_1.HttpCache; } });
var default_cache_1 = require("./default-cache");
Object.defineProperty(exports, "DefaultHttpCache", { enumerable: true, get: function () { return default_cache_1.DefaultHttpCache; } });
